// src/components/layout/Footer.jsx
import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { 
  Mail,
  Phone,
  MapPin,
  TrendingUp
} from 'lucide-react'
import Logo from '../../assets/logos.png'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Investment Tiers', href: '/services' },
    { name: 'About Us', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ]

  const legalLinks = [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },

  ]

  return (
    <footer className="bg-[#811844] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-1"
          >
            <Link to="/" className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-r from-[#F5AD16] to-[#F5AD18] rounded-xl flex items-center justify-center">
                <img src={Logo} alt="TGFuture Logo" className="w-8 h-8" />
              </div>
              <div>
                <h1 className="text-xl font-bold">TGFuture</h1>
                <p className="text-sm text-gray-400">Wealth Management</p>
              </div>
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Building lasting wealth through strategic investments and innovative financial solutions for a secure future.
            </p>
            {/* <div className="flex space-x-4">
              <div className="w-10 h-10 bg-[#F5AD18] hover:bg-[#9E1C60] rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <span className="text-lg font-semibold">f</span>
              </div>
              <div className="w-10 h-10 bg-[#F5AD18] hover:bg-[#9E1C60] rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <span className="text-lg font-semibold">in</span>
              </div>
              <div className="w-10 h-10 bg-[#F5AD18] hover:bg-[#9E1C60] rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <span className="text-lg font-semibold">t</span>
              </div>
            </div> */}
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h3 className="text-lg font-bold mb-6 text-[#F5AD18]">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-[#F5AD18] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Legal */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h3 className="text-lg font-bold mb-6 text-[#F5AD18]">Legal</h3>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-[#F5AD18] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <h3 className="text-lg font-bold mb-6 text-[#F5AD18]">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-[#F5AD18]" />
                <a 
                  href="mailto:support@tgfuture.com"
                  className="text-gray-400 hover:text-[#F5AD18] transition-colors"
                >
                  support@tgfuture.com
                </a>
              </div>
              {/* <div className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-[#F5AD18]" />
                <span className="text-gray-400">
                  +1 (555) 123-4567
                </span>
              </div> */}
              <div className="flex items-center space-x-3">
                <MapPin className="w-4 h-4 text-[#F5AD18]" />
                <span className="text-gray-400">
                  New York, NY 10001
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} TGFuture Wealth Management. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span>Secure Investing</span>
              <span>•</span>
              <span>Regulated</span>
              <span>•</span>
              <span>SSL Encrypted</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer